/**
 * Composition method for EPIC HR Lyra data
 * 
 * Author: Andrea López
 */
import { computed, ref, watchEffect } from 'vue';
import { useStore } from 'vuex';

import { $lyraEndpoints, getLyraEndpoints } from '@/core/modules/lyra/services';

import citationsConfig from '@/core/modules/citations/config/citations.config';

export function epicDataComposition () {
	const store = useStore();

	// Computed section data
	const sections = computed((): any[] => {
		const epicSections = getLyraEndpoints('epic-hr');
		if (!epicSections) { return []; }

		return epicSections;
	});

	// Computed data
	const datum = computed((): any[] => {
		let returnData: any[] = [];

		const epicFrames = getLyraEndpoints('epic-hr-frames');
		(sections.value || []).forEach((section: any) => {
			let frames: any[] = epicFrames.filter((_: any) => _['epic-hr'] === section.endpointId);
			frames = frames.sort((a: any, b: any) => parseFloat(a.order) - parseFloat(b.order));

			frames.forEach((obj: any) => {
				obj.section = section.endpointId;
			});
			returnData = returnData.concat(frames);
		});

		return returnData;
	});

	// Citations
	const hasEndpointData = ref<boolean>(false);
	const activeFrame = computed((): string => store.getters.get_ehrActiveFrame);
	const citationsType = ref<string[]>([]);
	const citationsTypes = citationsConfig.map((_: any) => _.type);
	const endpointData: any = ref<any>({});

	watchEffect(async () => {
		hasEndpointData.value = false;
		endpointData.value = await $lyraEndpoints({
			endpointId: activeFrame.value,
			tierId: 'epic-hr-frames'
		});
		hasEndpointData.value = (Object.keys(endpointData.value).length > 0);
	});

	return { 
		sections, datum, citationsTypes, citationsType, endpointData,
		hasEndpointData
	}
}
